import { createSequence } from '@rst/libs-ts'
import { scroller, animateScroll } from 'react-scroll'
import { $historyHashString } from '@rst/libs-ts'
import { createEvent, guard, merge } from 'effector'
import { $historyPathname, $page } from './page'

const initScrollToBlock = () => {
	const initDocument = createEvent()
	const loadingPage = guard($page, { filter: x => x?.loading === 'done' })

	const changeHashRout = guard($historyHashString, {
		filter: x => !!x,
	})

	const sequenceLoadingPage = createSequence(
		merge([initDocument, changeHashRout]),
		loadingPage
	)

	const scrollTop = guard($historyPathname, {
		filter: $historyHashString.map(x => !x),
	})

	const scrollFn = () => {
		const hash = (window?.location?.hash || '')?.slice(1)
		if (!hash) return

		let counts = 0
		const interval = setInterval(() => {
			const block = document.getElementById(hash)
			if (!block) {
				if (counts > 10) clearInterval(interval)
				counts++
				return
			}
			clearInterval(interval)
			scroller.scrollTo(hash, {
				duration: 300,
				offset: -250,
				delay: 0,
				smooth: 'easeInOutQuart',
			})
		}, 200)
	}

	sequenceLoadingPage.watch(scrollFn)
	scrollTop.watch(() => {
		animateScroll.scrollToTop()
	})

	$page.watch(page => {
		// @ts-ignore
		if (page.data && window.__page__) {
			//forceShowAllBlocks()
			new Promise(res => {
				setTimeout(res, 1500)
			}).then(scrollFn)
		}
	})

	initDocument()
}

export default initScrollToBlock
